const getLocale = (rootState) => rootState.locale;

export default getLocale;
